// import * as React from 'react';
// import { useTheme } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import Chip from '@mui/material/Chip';

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

// const names = [
//   'Oliver Hansen',
//   'Van Henry',
//   'April Tucker',
//   'Ralph Hubbard',
//   'Omar Alexander',
//   'Carlos Abbott',
//   'Miriam Wagner',
//   'Bradley Wilkerson',
//   'Virginia Andrews',
//   'Kelly Snyder',
// ];

// function getStyles(name, personName, theme) {
//   return {
//     fontWeight:
//       personName.indexOf(name) === -1
//         ? theme.typography.fontWeightRegular
//         : theme.typography.fontWeightMedium,
//   };
// }

// export default function Menu1({domainExpertise ,setDomainExpertise}) {
//   const theme = useTheme();
//   const [personName, setPersonName] = React.useState([]);

//   const handleChange = (event) => {
//     const {
//       target: { value },
//     } = event;
//     setPersonName(
//       // On autofill we get a stringified value.
//       typeof value === 'string' ? value.split(',') : value,
//     );
//   };

//   return (
//     <div>
//       <FormControl sx={{ m: 1, width:"100%" }}>
//         <InputLabel id="demo-multiple-chip-label">Choose your Topic/Subject</InputLabel>
//         <Select
//           labelId="demo-multiple-chip-label"
//           id="demo-multiple-chip"
//           multiple
//           value={personName}
//           onChange={handleChange}
//           input={<OutlinedInput id="select-multiple-chip" label="Choose your Topic/Subject" />}
//           renderValue={(selected) => (
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//               {selected.map((value) => (
//                 <Chip key={value} label={value} />
//               ))}
//             </Box>
//           )}
//           MenuProps={MenuProps}
//         >
//           {names.map((name) => (
//             <MenuItem
//               key={name}
//               value={name}
//               style={getStyles(name, personName, theme)}
//             >
//               {name}
//             </MenuItem>
//           ))}
//         </Select>
//       </FormControl>
//     </div>
//   );
// }

import React, { useState } from "react";
import {
  OutlinedInput,
  InputLabel,
  MenuItem,
  Select,
  FormControl,
  Stack,
  Chip,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
export default function Menu1({ domainExpertise, setDomainExpertise }) {
  const [selectedNames, setSelectedNames] = useState([]);
  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel>Choose your Topic/Subject </InputLabel>
      <Select
        multiple
        value={domainExpertise}
        onChange={(e) => setDomainExpertise(e.target.value)}
        input={<OutlinedInput label="Choose your Topic/Subject " />}
        renderValue={(domainExpertise) => (
          <Stack gap={1} direction="row" flexWrap="wrap">
            {domainExpertise.map((value) => (
              <Chip
                key={value}
                label={value}
                onDelete={() =>
                  setDomainExpertise(
                    domainExpertise.filter((item) => item !== value)
                  )
                }
                deleteIcon={
                  <CancelIcon
                    onMouseDown={(event) => event.stopPropagation()}
                  />
                }
              />
            ))}
          </Stack>
        )}
      >
        <MenuItem disabled style={{ fontWeight: 800, fontSize: "30px" }}>
          Data Science
        </MenuItem>
        <MenuItem value="Artificial Intelligence">
          Artificial Intelligence
        </MenuItem>
        <MenuItem value="Big Data">Big Data</MenuItem>
        <MenuItem value="Cloud Computing">Cloud Computing</MenuItem>
        <MenuItem value="Data Analysis">Data Analysis</MenuItem>
        <MenuItem value="Data Mining">Data Mining</MenuItem>
        <MenuItem value="Machine Learning">Machine Learning</MenuItem>
        <MenuItem value="Power BI">Power BI</MenuItem>
        <MenuItem value="Python">Python</MenuItem>

        <MenuItem disabled style={{ fontWeight: 800, fontSize: "30px" }}>
          Mathematical science
        </MenuItem>
        <MenuItem value="Differential Calculus">Differential Calculus</MenuItem>
        <MenuItem value="Integral Calculus">Integral Calculus</MenuItem>
        <MenuItem value="Linear Algebra">Linear Algebra</MenuItem>
        <MenuItem value="Real Analysis">Real Analysis</MenuItem>
        <MenuItem value="Linear Programming"> Linear Programming</MenuItem>
        <MenuItem value="Statistics">Statistics</MenuItem>
        <MenuItem value="Probability">Probability</MenuItem>
        <MenuItem value="Complex Analysis">Complex Analysis</MenuItem>
        <MenuItem value="Differential Equation">Differential Equation</MenuItem>
        <MenuItem value="Geometry">Geometry</MenuItem>
        <MenuItem value="Topology">Topology</MenuItem>

        <MenuItem disabled style={{ fontWeight: 800, fontSize: "30px" }}>
          Computer Science
        </MenuItem>
        <MenuItem value="Azure">Azure</MenuItem>
        <MenuItem value="Blockchain">Blockchain</MenuItem>
        <MenuItem value="C Programming">C Programming</MenuItem>
        <MenuItem value="DevOps">DevOps</MenuItem>
        <MenuItem value="Full Stack Development">
          Full Stack Development
        </MenuItem>
        <MenuItem value="HTML">HTML</MenuItem>
        <MenuItem value="Java">Java</MenuItem>
        <MenuItem value="JavaScript">JavaScript</MenuItem>
        <MenuItem value="Python">Python</MenuItem>
      </Select>
    </FormControl>
  );
}
